/**
 * Frontend version utilities
 */

// This will be replaced during build with actual version from package.json
export const FRONTEND_VERSION = '1.51.0';

/**
 * Get build information for frontend
 */
export function getFrontendBuildInfo() {
  const buildTime = new Date().toISOString();
  const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : 'Server';

  return {
    version: FRONTEND_VERSION,
    buildTime,
    userAgent,
    environment: import.meta.env.MODE || 'development',
    url: typeof window !== 'undefined' ? window.location.href : 'Server'
  };
}

/**
 * Log frontend version information
 */
export function logFrontendVersion() {
  if (typeof window !== 'undefined') {
    const buildInfo = getFrontendBuildInfo();
    console.log('🎨 PadELO Frontend');
    console.log(`📦 Version: ${buildInfo.version}`);
    console.log(`🌍 Environment: ${buildInfo.environment}`);
    console.log(`⏰ Build Time: ${buildInfo.buildTime}`);
    console.log(`🌐 URL: ${buildInfo.url}`);
    console.log('─'.repeat(30));
  }
}

/**
 * Parses and compares Semantic Versioning strings.
 * Expected format "major.minor.patch" (e.g., "1.2.0")
 */
export function parseVersion(version: string): number[] {
  // Extract major, minor, patch, ignoring any prerelease tags for simple comparison
  const cleanVersion = (version || "").replace(/[^0-9.]/g, '');
  const parts = cleanVersion.split('.');
  return [
    parseInt(parts[0] || '0', 10),
    parseInt(parts[1] || '0', 10),
    parseInt(parts[2] || '0', 10),
  ];
}

/**
 * Returns true if v1 is LESS THAN v2 (older).
 * @param v1 The version to check (e.g. current app version)
 * @param v2 The minimum required version
 */
export function isVersionOlder(v1: string, v2: string): boolean {
  if (!v1 || !v2) return false;

  const parts1 = parseVersion(v1);
  const parts2 = parseVersion(v2);

  for (let i = 0; i < 3; i++) {
    if (parts1[i] < parts2[i]) return true;
    if (parts1[i] > parts2[i]) return false;
  }

  return false; // Equal versions
}
